import React, { useEffect, useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Grid,
    Tooltip,
    IconButton,
    Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { formatDateMX } from '../../../helpers/hours';
import { getCallById } from '../../../actions/prospections';
import { reasonMapping } from '../../utils/lists';
import { money } from '../../../helpers/utils';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 600,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    borderRadius: 2,
};

const mapReasonLabel = value => {
    const reason = reasonMapping.find(item => item.value === value);
    return reason ? reason.label : value;
};

const CopyableField = ({ label, value, onCopy, disableCopy }) => (
    <Grid item xs={12} display="flex" alignItems="center">
        <Typography variant="subtitle1" gutterBottom sx={{ flex: 1 }}>
            <strong>{label}:</strong>
        </Typography>
        <Typography
            variant="subtitle1"
            gutterBottom
            sx={{ textAlign: 'right', flex: 1 }}
        >
            {value || '-'}
        </Typography>
        {!disableCopy && value && (
            <Tooltip title="Copiar" placement="top" arrow>
                <IconButton
                    onClick={() => onCopy(value)}
                    size="small"
                    aria-label={`Copiar ${label}`}
                >
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
            </Tooltip>
        )}
    </Grid>
);

export const ProspectionDetailsModal = ({ open, onClose, prospectionId }) => {
    const [prospection, setProspection] = useState(null);
    const [showObservations, setShowObservations] = useState(false);

    useEffect(() => {
        if (open && prospectionId) {
            getCallById(prospectionId)
                .then(response => setProspection(response.data))
                .catch(() => console.error('Error al cargar la prospección'));
        }
    }, [open, prospectionId]);

    if (!prospection) return null;

    const toggleObservations = () => setShowObservations(!showObservations);

    return (
        <Modal open={open} onClose={onClose} aria-labelledby="modal-title">
            <Box sx={style}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                >
                    <Typography
                        id="modal-title"
                        variant="h6"
                        sx={{ fontWeight: 'bold' }}
                    >
                        Detalles de la Prospección
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        aria-label="Cerrar"
                        size="small"
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <Grid container spacing={2}>
                    <CopyableField
                        label="ID"
                        value={prospection.id}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Nombre del Cliente"
                        value={prospection.name}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Teléfono"
                        value={prospection.phone_number}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Correo Electrónico"
                        value={prospection.email}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Valor de Venta"
                        value={
                            prospection.sale_value
                                ? money(prospection.sale_value)
                                : 'N/A'
                        }
                        onCopy={text =>
                            navigator.clipboard.writeText(
                                money(prospection.sale_value)
                            )
                        }
                    />
                    <CopyableField
                        label="Fecha de Creación"
                        value={formatDateMX(prospection.created_at)}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Motivo de No Compra"
                        value={mapReasonLabel(prospection.non_purchase)}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    <CopyableField
                        label="Asesor"
                        value={prospection.adviser}
                        onCopy={text => navigator.clipboard.writeText(text)}
                    />
                    {showObservations && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>
                                <strong>Observaciones:</strong>
                            </Typography>
                            <Box
                                sx={{
                                    p: 1,
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 1,
                                    bgcolor: '#f9f9f9',
                                }}
                            >
                                <Typography variant="body2">
                                    {prospection.observations || '-'}
                                </Typography>
                            </Box>
                        </Grid>
                    )}
                </Grid>
                <Button
                    onClick={toggleObservations}
                    sx={{
                        textTransform: 'none',
                        color: '#1976d2',
                        mt: 2,
                        display: 'flex',
                        mx: 'auto',
                    }}
                >
                    {showObservations
                        ? 'Ocultar Observaciones'
                        : 'Mostrar Observaciones'}
                </Button>
                <Box display="flex" justifyContent="flex-end" mt={3}>
                    <Button
                        onClick={onClose}
                        sx={{ color: 'red', textTransform: 'none' }}
                    >
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};
